import countries from '@percent/workplace-giving/i18n/countries'

export const DONATION_DISALLOWED_ORG_COUNTRIES = [
  'BLR',
  'CUB',
  'IRN',
  'KAZ',
  'PRK',
  'LBY',
  'MMR',
  'RUS',
  'SSD',
  'SDN',
  'SYR',
  'VEN',
  'ATA',
  'AZE',
  'BVT',
  'IOT',
  'ATF',
  'HMD',
  'PCN',
  'SGS',
  'AFG',
  'ALB',
  'ASM',
  'BHS',
  'BRB',
  'BWA',
  'BFA',
  'BDI',
  'CPV',
  'KHM',
  'CAF',
  'COD',
  'DOM',
  'SLV',
  'ERI',
  'ETH',
  'GHA',
  'GUM',
  'GTM',
  'GNB',
  'GUY',
  'HTI',
  'HND',
  'IRQ',
  'JAM',
  'JOR',
  'LBN',
  'MAC',
  'MLI',
  'MDA',
  'MAR',
  'MOZ',
  'NIC',
  'NGA',
  'MNP',
  'PAK',
  'PSE',
  'PAN',
  'BLM',
  'KNA',
  'LCA',
  'WSM',
  'SEN',
  'SXM',
  'SOM',
  'SJM',
  'TJK',
  'TZA',
  'TTO',
  'TKM',
  'UGA',
  'VUT',
  'ESH',
  'YEM',
  'ZWE',
  'CHN'
]

export const VOLUNTEER_DISALLOWED_ORG_COUNTRIES = ['CUB', 'IRN', 'PRK', 'MMR', 'RUS', 'SDN', 'SYR']

export const donationAllowedOrgCountriesAlpha3 = Object.keys(countries.getAlpha3Codes()).filter(
  alpha3 => !DONATION_DISALLOWED_ORG_COUNTRIES.includes(alpha3)
)

export const volunteeringAllowedOrgCountriesAlpha3 = Object.keys(countries.getAlpha3Codes()).filter(
  alpha3 => !VOLUNTEER_DISALLOWED_ORG_COUNTRIES.includes(alpha3)
)
